import querystring from 'query-string'
import { AppState } from '@halo/stores/app.state'
import { AppService } from '@halo/services/app.service'
import { axiosFetch, isAxiosResponseError } from '@halo/_utils/axios'
import { Singleton, Container } from 'typescript-ioc/es5'
import { simpleNotification } from '@halo/_utils/notifications'
import aqe from '@pushly/aqe'
import { IApiCallOptions, IApiResponse } from '@pushly/aqe/lib/interfaces'
import { Industry } from '@pushly/models/lib/structs/industry'
import { hydrateIndustryModel } from '@halo/_utils/models-hydration'

@Singleton
export class ApiEnumService {
    private appState: AppState
    private appService: AppService

    public constructor() {
        this.appState = Container.get(AppState)
        this.appService = Container.get(AppService)
    }

    public async fetchAllCurrencies(opts: IApiCallOptions = {}): Promise<IApiResponse<any[]>> {
        let ok = false
        let currencies: any[] = []
        let meta: any

        if (opts.showLoadingScreen) {
            this.appService.setModuleLoading()
        }
        const options = querystring.stringify(opts.query || {})
        const serviceURL = `${aqe.defaults.publicApiDomain}/v3/enums/currencies?${options}`

        try {
            const res = await axiosFetch(
                'get',
                {
                    url: serviceURL,
                },
                opts.cancellationKey,
            )
            const { data, ...resMeta } = res.data

            ok = true
            currencies = data
            meta = resMeta
        } catch (error) {
            if (isAxiosResponseError(error)) {
                simpleNotification('error', error.response.data.message)
            }
        }

        if (opts.showLoadingScreen) {
            this.appService.unsetModuleLoading()
        }

        return { ok, data: currencies, meta }
    }

    public async fetchAllIndustries(opts: IApiCallOptions = {}): Promise<IApiResponse<Industry[]>> {
        let ok = false
        let industries: Industry[] = []
        let meta: any

        if (opts.showLoadingScreen) {
            this.appService.setModuleLoading()
        }
        const options = querystring.stringify(opts.query || {})
        const serviceURL = `${aqe.defaults.publicApiDomain}/v3/enums/industries?${options}`

        try {
            const res = await axiosFetch(
                'get',
                {
                    url: serviceURL,
                },
                opts.cancellationKey,
            )
            const { data, ...resMeta } = res.data

            ok = true
            industries = data.map((industry: Industry) => hydrateIndustryModel(industry))
            meta = resMeta
        } catch (error) {
            if (isAxiosResponseError(error)) {
                simpleNotification('error', error.response.data.message)
            }
        }

        if (opts.showLoadingScreen) {
            this.appService.unsetModuleLoading()
        }

        return { ok, data: industries, meta }
    }
}
